<template>
  <div class="ma-3">
    <div class="title mb-3">
      Planning <v-icon>mdi-chevron-right</v-icon> Period types
    </div>

    <div
      layout="column"
      layout-align="center center"
    >
      <div
        layout="column"
        class="field-width"
      >
        <div
          layout="row"
          layout-align="start center"
          class="ml-3"
        >
          <v-text-field
            v-model="filters.keywords"
            solo
            label="Keywords"
            hide-details
            @keyup.enter="fetch"
          />
          <v-btn
            depressed
            color="primary"
            @click="fetch"
          >
            Filter
          </v-btn>
          or
          <a
            href="#"
            class="ml-2 black--text"
            @click="resetFilters"
          >Cancel</a>
        </div>

        <div>
          <v-btn
            flat
            class="mt-3"
            :to="{name: 'admin-planning-periodtypes-edit', params: {id: 'new'}}"
          >
            <v-icon
              left
              color="primary"
            >
              mdi-plus-box
            </v-icon>
            Add a new period type
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="periods"
          style="max-width: 1000px"
          :pagination.sync="pagination"
        >
          <template
            slot="items"
            slot-scope="{ item }"
          >
            <td>
              <span :style="`color: ${item.color}; font-size: 32px; font-weight: bold;`">&bullet;</span>
            </td>
            <td>{{ item.name }}</td>
            <td>
              <v-checkbox
                v-model="item.is_default"
                readonly
                :true-value="1"
                :false-value="0"
                hide-details
              />
            </td>
            <td layout="row">
              <v-btn
                class="mx-0"
                icon
                :to="{name: 'admin-planning-periodtypes-edit', params: {id: item.id}}"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <delete-button
                :label="item.name"
                @confirm="deleteImpl(item)"
              />
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
    import Params from '@/api/params'
    import DeleteButton from "@/components/shared/DeleteButton.vue"

    export default {
        components: {DeleteButton},
        data () {
            return {
                pagination: {
                    rowsPerPage: 10
                },
                headers: [
                    { text: '', sortable: false, width: 40 },
                    { text: 'Type', value: 'name' },
                    { text: 'Default', value: 'is_default' },
                    { text: 'Actions', sortable: false, width: "80px" }
                ],
                filters: {
                    keywords: null
                },
                periods: []
            }
        },
        mounted () {
            this.fetch();
        },
        methods: {
            fetch () {
                Params.getList('periods-types', this.filters).then(res => {
                    this.periods = res.data;
                })
            },

            resetFilters () {
                this.filters = {keywords: null};
                this.fetch();
            },

            deleteImpl (item) {
                Params.delete('periods-types', item.id).then(() => {
                    this.fetch();
                    this.$snotify.success(`The period "${item.name}" has been deleted`)
                })
            }
        }
    }
</script>